//POP UP
/**
 * Pop up content for links where this criteria:
 * - can be image, iframe (page), video (YouTube/Vimeo), anchor (hidden on-page content)
 * - will attempt to determin content type automatically, though can be provided via data-popUpType attribute
 * - example1: <a href="popup://#element-id" class="btn">Show Content</a>
 * - example2: <a href="/path-to/pop-up-image.svg" class="btn">Show Image</a>
 * - example3: <a class="pop-up btn" href="/iframe-content">Show Content</a>
 * - example4: <a data-popUpType="youtube" href="QZShA_a-5r8" class="btn">Show Video</a>
 *
 */

jQuery("body").on(
  "click",
  '.pop-up,.pop-up a,a[href^="popup://"],a[href$=".jpg"],a[href$=".jpeg"],a[href$=".svg"],a[href$=".png"],a[href$=".gif"],.pop-up-image .text-and-slide-columns__img .slide img',
  function (e) {
    e.preventDefault();
    e.stopPropagation();

    //remove any previous pop-up still animating out...
    $(".pop-up-container").remove();

    var assetTitle = $(this).attr("title");
    var asset = $(this).attr("href"); //.replace("popup://","");
    //use img src if no href?
    console.log("Pop-up asset href = " + asset);
    if (asset == "" || asset == "undefined" || typeof asset == "undefined") {
      asset = $(this).attr("src");
      console.log("Pop-up asset src = " + asset);
    }
    var contentStyle = ""; //obsolete?
    var imgClass = "";
    var assetType = $(this).attr("data-popUpType");
    if (typeof assetType == "undefined") {
      var imgExts = ["jpg", "jpeg", "png", "svg", "gif"];
      var fileExt = asset.split(".").pop();
      if (imgExts.indexOf(fileExt) >= 0) {
        assetType = "image";
        imgClass = " " + fileExt;
        // if(fileExt=="svg"){
        // contentStyle=' style="background-color: #fff;"';
        // }
      } else if (
        (($(this).hasClass("pop-up") || $(this).parent(".pop-up").length > 0) &&
          asset.substr(0, 1) == "#") ||
        asset.substr(0, 9) == "popup://#"
      ) {
        // WP menu class name is applied to parent <LI>
        assetType = "anchor";
      }
    }
    console.log("assetType: " + assetType);

    if (typeof asset != "undefined") {
      asset = asset.replace("popup://", "");
    }

    var loader = $(
      '<div class="loader"><div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>'
    ); //https://loading.io/css/
    var close = $('<span class="close">x</span>');
    var container = $('<div class="pop-up-container init"></div>');
    var containerContent = $(
      '<div class="pop-up-container__content' +
        imgClass +
        '" ' +
        contentStyle +
        "></div>"
    );

    if (assetType == "image") {
      //* TODO: prev/next arrows/keys for other images in gallery? (e.g. get .pop-up siblings)
      // containerContent=$('<div class="pop-up-container__content"><img src="'+asset+'"></div>');
      // containerContent.append($('<img src="'+asset+'">'));
      var imageAlt = $(this).find("img").attr("alt");

      var figure = $("<figure></figure>");
      var image = $('<img src="' + asset + '" alt="' + imageAlt + '">');
      var caption =
        assetTitle != ""
          ? $("<figcaption>" + assetTitle + "</figcaption>")
          : $("");
      figure.append(image).append(caption);
      containerContent.append(figure);
    }

    if (assetType != "image") {
      if (assetType == "content") {
        var $item = "#" + $(this).attr("data-content");
        console.log("item cloned (AOS removed)", $item);
        // var $content=$($item).clone().removeAttr("data-aos").removeAttr("data-aos-delay");
        var $content = $($item)
          .clone()
          .removeAttr("data-aos")
          .removeAttr("data-aos-delay")
          .removeClass("pop-up");
        //containerContent=$("#pop-up-content .modal__content").addClass("content").html("").append($content);

        containerContent = $content;
      } else if (assetType == "anchor") {
        console.log("Anchor pop-up (NOT CLONED - AOS removed) " + asset);
        if ($(asset).length > 0) {
          var $content = $(asset); //.clone();
        } else {
          // alert("Sorry, the requested content is not available on this page ("+asset+")");
          var $content = $(
            "<h2>Sorry, the requested content is not available on this page (" +
              asset +
              ")</h2>"
          );
          $content.addClass("error-message");
        }
        //$content.find("iframe").trigger("load");
        $content
          .removeAttr("data-aos")
          .removeAttr("data-aos-delay")
          .removeClass("OFF")
          .removeClass("off")
          .addClass("anchor-pop-up-content");
        containerContent.addClass("anchor-pop-up").append($content);
      } else if ("youtube" == assetType.toLowerCase()) {
        var youTubeFrame = $(
          '<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://www.youtube.com/embed/' +
            asset +
            '" title="YouTube video player" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>'
        );
        containerContent.append(youTubeFrame);
      } else if ("vimeo" == assetType.toLowerCase()) {
        var vimeoFrame = $(
          '<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/' +
            asset +
            '?autoplay=1&color=ffffff&title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>'
        );
        containerContent.append(vimeoFrame);
      } else {
        assetType = "iframe";
        var containerFrame = $('<iframe src="' + asset + '"></iframe>');
        // containerContent=$('<div class="pop-up-container__content"><iframe src="'+asset+'"></iframe></div>');
        containerContent.append(containerFrame);
      }
    }

    container.addClass("pop-up-type-" + assetType);
    container.append(close);
    container.append(loader);
    container.append(containerContent);
    $("body").append(container);
    //animate entry with CSS...
    container.removeClass("init");
  }
);

jQuery("body").on(
  "click",
  ".pop-up-container .close,.pop-up-container .close-btn",
  function () {
    if ($(this).parents(".pop-up-container").hasClass("pop-up-type-anchor")) {
      // $content.removeClass("OFF").removeClass("off").addClass("anchor-pop-up-content");
      var content = $(this)
        .parents(".pop-up-container")
        .find(".anchor-pop-up-content");
      $("#hidden-content").append(content);
      console.log("Pop-up asset moved to #hidden-content");
    }
    $(this).parents(".pop-up-container").addClass("init");
    setTimeout(function () {
      console.log("removing pop-up from DOM");
      $(".pop-up-container").remove();
    }, 600);
    // $(this).parents(".pop-up-container").remove();
  }
);
